<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flex-spc-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>手机端设置</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="flexc-cen-x" style="margin-right:220px">
        <el-popover
            placement="bottom"
            trigger="click"
          >
          <img v-if="show == false" src="../../assets/img/loading1.gif" alt="" style="width:100px;height:100px" srcset="">
           <img v-if="show == true" :src="xcxPhthls" alt="" style="width:100px;height:100px" srcset="">
          <el-button size="mini"  slot="reference" @click="toyu"  type="primary" icon="el-icon-caret-right" style="margin-right:20px"> 预览</el-button>
        </el-popover>
        <el-popover
          placement="bottom"
          trigger="click"
        >
           <img :src="xcxPhth1" alt="" style="width:100px;height:100px" srcset="">
          <el-button size="mini"  slot="reference"   type="success" icon="el-icon-date" style="margin-right:20px"> 预约二维码</el-button>
         </el-popover>
          <el-button size="mini" @click="toSave" type="primary" icon="el-icon-folder-add"  style="margin-right:20px">保存</el-button>
         <el-link type="primary"  @click="toHome"><i class="el-icon-back"></i> 返回</el-link>
      </div>
    </div>
    <div class="flex-spc-x contain">
       <div class="left">
        <el-collapse v-model="activeNames" >
            <el-collapse-item title="基础模块" name="1">
              <div class="moud" style="width:100%">
                  <div v-for=" items in  module" @click="toChoose(items)" :class="[items.show?' boxx flex-xy':'box  flex-xy']">
                      <i :class="items.icon" style="font-size:30px;color: rgb(76, 76, 76);"></i>
                      <div class="font">{{items.name}}</div>
                  </div>
                </div>
            </el-collapse-item>
            <!-- <el-collapse-item title="菜单模块" name="2">

            </el-collapse-item> -->
             <el-collapse-item title="主题颜色" name="3">
                <div class="flex-spc-x" style="width:90%;margin-left:5%;margin-top:10px">
                  <div v-for="items in list.listStoresColor" class="quan" style="">
                    <div v-if="list.StoresInfo.templateType === items.ID">
                          <div class="bgColor1" :style="{background:items.bgColor}"></div>
                    </div>
                    <div v-else @click="toColor(items)">
                        <div class="bgColor" :style="{background:items.bgColor}"></div>
                    </div>
                  </div>
                </div>
             </el-collapse-item>
        </el-collapse>
       </div>
       <div class="main flex-xy">
           <div class="phone">
               <img src="../../assets/back.png" alt="" srcset="" style="width:100%">
                <div class="mian" style="margin-top:10px;width:100%;margin-bottom:30px"  @dragover="dragover($event)">
                  <transition-group class="transition-wrapper" name="sort" :key="timer">
                    <div v-for="(items,index) in ListPreAboutForms" :key='items.type' style="margin-top:10px"   
                      :draggable="true"
                      @dragstart="dragstart(items)"
                      @dragenter="dragenter(items,$event)"
                      @dragend="dragend(items,$event)"
                      @dragover="dragover($event)"
                      @mouseenter="onMouseOver(items)"
                      @mouseleave="onMouseLeave(items)"
                      @click="clickitems(items)"
                      :class="[items.clickShow?' hen1 flex-xy':'hen  flex-xy']"
                    >
                    <!-- v-if="items.show" -->
                      <div class="topButton flexc-cen-x" v-if="items.show" >
                        <div class="buttonbac flex-xy" v-if="index != 0" @click="toTop(items,index)">上移</div>
                        <div class="buttonbac flex-xy" v-if="index != ListPreAboutForms.length - 1" @click="toDown(items,index)" style="margin-left:3px">下移</div>
                        <div class="buttonbac flex-xy" style="margin-left:3px"  @click="delItems(items,index)">删除</div>
                      </div>
                      <div class="imgbg flex-xy" v-if="items.type == 'lbt'" style="font-size:15px;width:100%;">
                          <i class="el-icon-picture" style="font-size:10vh;color:#808080"></i>
                          <div>点击编辑轮播图</div>
                          <!-- <i class="el-icon-delete-solid coBlue" style="margin-right:2%;font-size:15px" @click="todel(items,index)"></i> -->
                      </div>  
                      <div :class="[menu1.length>4?' moud ':' flex-spc-x ']" v-if="items.type == 'dhcd'" style="font-size:15px;width:100%;padding:10px">
                          <div v-for=" item in  menu1" :key='item.name' class="box3  flex-xy">
                            <img :src="item.url" alt="" srcset="" style="width:25px;height:25px">
                              <!-- <i class="el-icon-picture icon1"></i> -->
                            <div class="font1">{{item.name}}</div>
                          </div>
                            <!-- <i class="el-icon-picture" style="font-size:10vh;color:#808080"></i> -->
                        <!-- <div>点击编辑图片</div> -->
                          <!-- <i class="el-icon-delete-solid coBlue" style="margin-right:2%;font-size:15px" @click="todel(items,index)"></i> -->
                      </div>  
                      <div class="terbg  flex-xy" v-if="items.type == 'pro'" style="font-size:15px;width:100%;">
                          <i class="el-icon-s-order" style="font-size:10vh;color:#808080"></i>
                           <div>点击编辑{{items.name}}</div>  
                      </div>  
                      <div class="terbg  flex-xy" v-if="items.type == 'hd'" style="font-size:15px;width:100%;">
                          <i class="el-icon-s-flag" style="font-size:10vh;color:#808080"></i>
                           <div>点击编辑{{items.name}}</div>  
                      </div>  
                      <div class="terbg flex-xy" v-if="items.type == 'ter'" style="font-size:15px;width:100%;">
                          <i class="el-icon-user-solid" style="font-size:10vh;color:#808080"></i>
                            <div>点击编辑{{items.name}}</div>
                         
                      </div>  
                      <div class="terbg flex-xy" v-if="items.type == 'gg'" style="font-size:15px;width:100%;">
                          <i class="el-icon-message-solid" style="font-size:10vh;color:#808080"></i>
                            <div>点击编辑{{items.name}}</div>
                      </div>  
                      <div class="imgbg  flex-xy" v-if="items.type == 'mdjs'" style="font-size:15px;width:100%;">
                            <i class="el-icon-s-shop" style="font-size:10vh;color:#808080"></i>
                            <div>点击编辑{{items.name}}</div>  
                      </div>  
                      <div class="jieshao  flex-xy" v-if="items.type == 'lxwm'" style="font-size:15px;width:100%;">
                        <div class="flex-spc-x" style="width:100%">
                          <div style="margin-left:20px">
                            <div class="flexc-cen-x">
                              <div>门店：</div>
                            </div>
                            <div class="flexc-cen-x" style="margin-top:10px">
                              <div>地址：</div>
                            </div>
                          </div>
                          <div class="flexc-cen-x" style="margin-right:20px">
                            <img src="../../assets/icon/ph.png" alt="" srcset="" style="width:4vh;height:4vh">
                              <img src="../../assets/icon/we.png" alt="" srcset="" style="width:4vh;height:4vh;margin-left:10px">
                          </div>
                        </div>

                      </div>
                    </div>
                  </transition-group>
                </div>
           </div>
       </div>
       <div class="right">   
            <div class="rightTitle">{{typeList.name}}配置</div>
            <div class="mian" v-if="typeList.type == 'dhcd'" style="margin-top:10px;width:100%"  @dragover="dragover1($event)">
                <transition-group class="transition-wrapper moud" name="sort" :key="timer1">
                    <!-- <div v-for=" (items,index) in  menu1" :key='items.name' class="box2  flex-xy"
                        :draggable="true"
                        @dragstart="dragstart1(items)"
                        @dragenter="dragenter1(items,$event)"
                        @dragend="dragend1(items,$event)"
                        @dragover="dragover1($event)"
                        @mouseenter="onMouseOver1(items)"
                        @mouseleave="onMouseLeave1(items)"
                    >
                      <div class="topButton flexc-cen-x" v-if="items.moveShow" >
                        <div class="buttonbac flex-xy" style="margin-left:3px"  @click="delItems1(items,index)">删除</div>
                      </div>
                        <img :src="items.url" alt="" srcset="" style="width:25px;height:25px">
                                    
                        <div class="font1">{{items.name}}</div>
                    </div> -->
                      <div v-for=" (items,index) in  menu"  :class="[items.show?' boxx1 flex-xy':'box1  flex-xy']" :key='items.MenuType'
                        :draggable="true"
                        @dragstart="dragstart1(items)"
                        @dragenter="dragenter1(items,$event)"
                        @dragend="dragend1(items,$event)"
                        @dragover="dragover1($event)"
                        @mouseenter="onMouseOver1(items)"
                        @mouseleave="onMouseLeave1(items)"
                      >
                      <div class="topButton flexc-cen-x" v-if="items.moveShow == true" >
                        <div class="buttonbac flex-xy" v-if="index != 0" @click="toTop1(items,index)">左移</div>
                        <div class="buttonbac flex-xy" v-if="index != menu.length - 1" @click="toDown1(items,index)" style="margin-left:3px">右移</div>
                        <!-- <div class="buttonbac flex-xy" style="margin-left:3px"  @click="delItems(items,index)">删除</div> -->
                      </div>
                      <div class="flex-xy" style="width:100%;height:100%" @click="toChoose1(items)">
                        <img :src="items.url" alt="" srcset="" style="width:25px;height:25px">
                        <div class="font1">{{items.name}}</div>
                      </div>
                        
                      </div>
                </transition-group>
            </div>       
            <div class="" v-if="typeList.type == 'lbt'" style="width:100%;height:95%;overflow:auto">
                <div class="list-img-box cursor">
                  <div v-if="img1 !== ''" class="flex-spc-x">
                    <img
                      :src="img1"
                      style="width:242px;height:162px"
                      alt="图片"
                       @click="uploadPicture('img1')"
                    />
                    <div class="buttonbac flex-xy" style="margin-left:3px"  @click="img1 = ''">删除</div>
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                     style="width:242px;height:162px"
                    @click="uploadPicture('img1')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                   <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px; ">上传</span>
                        
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" >
                  <div v-if="img2 !== ''" class="flex-spc-x">
                    <img
                      :src="img2"
                     style="width:242px;height:162px"
                      alt="图片"
                        @click="uploadPicture('img2')"
                    />
                     <div class="buttonbac flex-xy" style="margin-left:3px"  @click="img2 = ''">删除</div>
                  </div>

                  <div
                    v-else 
                    class="upload-btn"
                    style="width:242px;height:162px"
                    @click="uploadPicture('img2')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                    <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" >
                  <div v-if="img3 !== ''" class="flex-spc-x">
                    <img
                      :src="img3"
                     style="width:242px;height:162px"
                      alt="图片"
                       @click="uploadPicture('img3')"
                    />
                     <div class="buttonbac flex-xy" style="margin-left:3px"  @click="img3 = ''">删除</div>
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="width:242px;height:162px"
                    @click="uploadPicture('img3')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                 <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
               </div>


            </div>
            <div class="" v-if="typeList.type == 'lxwm'" style="width:100%;height: calc(95vh - 130px);overflow: auto;padding-top:20px">
                <el-form
                  label-width="90px"
                  :model="editForm"
                  :rules="rules"
                  ref="editForm"
                
                >
                  <el-form-item label="门店名称:" prop="StoresName">
                  <el-input
                    size="small"
                    v-model="list.StoresInfo.StoresName"
                    auto-complete="off"
                    placeholder="请输入门店名称"
                    style="width: 215px"
                  ></el-input>
                  </el-form-item>
                  <el-form-item label="联系电话:" prop="Phone">
                  <el-input
                    size="small"
                    v-model="list.StoresInfo.StoresPhone"
                    auto-complete="off"
                    placeholder="请输入门店电话"
                    style="width: 215px"
                  ></el-input>
                  </el-form-item>
                            <el-form-item label="省份:" prop="Province">
            <el-select  size="small" v-model="list.StoresInfo.Province" @change="tocity()" placeholder="请选择">
              <el-option
                v-for="item in provinceList"
                :key="item.ProvinceID"
                :label="item.ProvinceName"
                :value="item.ProvinceID">
              </el-option>
            </el-select>
            <!-- <el-cascader
              size="small"
              v-model="value"
      
            ></el-cascader> -->
                    <!-- :options="options"
              @change="handleChange" -->
          
          </el-form-item>
          <el-form-item label="城市:" prop="City">
            <el-select  size="small" v-model="list.StoresInfo.City" placeholder="请选择"  @change="toArea()">
              <el-option
                v-for="item in cityList"
                :key="item.CityID"
                :label="item.CityName"
                :value="item.CityID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域:" prop="Area">
            <el-select  size="small" v-model="list.StoresInfo.Area" placeholder="请选择">
              <el-option
                v-for="item in  DistrictList"
                :key="item.DistrictID"
                :label="item.DistrictName"
                :value="item.DistrictID">
              </el-option>
            </el-select>
            <!-- <el-cascader
              size="small"
              v-model="value"
      
            ></el-cascader> -->
                    <!-- :options="options"
              @change="handleChange" -->
          
          </el-form-item>
        
          <el-form-item label="详细地址:" prop="Address">
            <el-input
              size="small"
              v-model="list.StoresInfo.Address"
              auto-complete="off"
              placeholder="请输入详细地址"
              style="width: 215px"
            ></el-input>
          </el-form-item>
          <el-form-item label="精确坐标:" prop="DWAddress">
            <div class="map">
                <el-input v-model="list.StoresInfo.DWAddress"    size="small"  style="width:70%; " placeholder="请输入地址来直接查找相关位置"></el-input>
                 <el-button size="mini" type="primary" @click="searchMap()">搜索</el-button>
                <baidu-map
                  class="bmView"
                  :scroll-wheel-zoom="true"
                  :center="location"
                  :zoom="zoom"
                  @click="getLocationPoint"
                  ak="XC4D0Hgvsp243FB55rnRMBVuBX6TWZxi"
                >
                  <bm-view style="width:90%; height:300px; flex: 1"></bm-view>
                  <bm-local-search :keyword="map" :auto-viewport="true" :location="location" :autoViewport="true" :pageCapacity="5"  @infohtmlset="choo"></bm-local-search>
                   <!-- <bm-polygon :path="polygonPath"></bm-polygon> -->
                </baidu-map>
            </div>
            <div id="r-result"></div>
          </el-form-item>
                  <!-- <el-form-item label="详细地址:" prop="Address">
                  <el-input
                    size="small"
                    v-model="list.StoresInfo.Address"
                    auto-complete="off"
                    placeholder="请输入详细地址"
                    style="width: 215px"
                  ></el-input>
                  </el-form-item> -->
                  
                </el-form>
            </div>
            <Editor :key="timer" v-if="typeList.type == 'mdjs'" v-bind:value="list.StoresInfo.StoresInfo" v-model="list.StoresInfo.StoresInfo"  style="width:100%;">
            </Editor>
       </div>
    </div>
    <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
    </el-dialog>
    <!--查看大封面-->
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
              <img
                :src="imgName"
                v-if="imgVisible"
                style="width: 100%"
                alt="查看"
              />
    </el-dialog>
    <!-- 搜索筛选 -->
  </div>
</template>
<script>
import CropperImage from "../../components/CropperImage";
import  Editor from '../../components/editor'
import Pagination from "../../components/Pagination";
import {getListCity,getListDistrict } from "@/api/getData";
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmView from 'vue-baidu-map/components/map/MapView.vue'
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'
export default {
  data() {
    return {
            location: {
        lng: 116.404,
        lat: 39.915
      },
            zoom: 12.8,
      addressKeyword: "",
      StoresInfo:'',
      activeNames: ['1','3'],
      ListPreAboutForms:[],
      timer:new Date().getTime(),
      open:true,
      img1:'',
      img2:'',
      img3:'',
      sh:'',
      provinceName:'',
      cityName:'',
      AreaName:'',
      map:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      SelectStoresID:this.$route.params.id,
      list:[],
      timer1:new Date().getTime(),
      title: "添加",
      imgVisible:false,
      xcxPhth1:localStorage.getItem("xcxPhth1"),
      cropperName:'',
      editForm: {
        deptId: "",
        deptName: "",
        deptNo: "",
        token: localStorage.getItem("logintoken"),
        KFQrCode:'',
      },
      typeList:'',
      show:false,
      module:[
         
      ],
      menu:[
         
      ],
      menu1:[],
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
        deptNo: [
          { required: true, message: "请输入部门代码", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
       imgName: "",
      provinceList:[],
      provinceName:'',
      cityName:'',
      AreaName:'',
      cityList:[],
      DistrictList:[],
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },

      cropperModel:false,
      userparm: [], //搜索权限
      listData: [], //用户数据
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    xcxPhthls:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
      Editor,
    CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.xcxPhthls = localStorage.getItem('xcxPhthls')
    this.getList()
    this.sh = 0
 this.getListProvince()
 this.getListDistrict()
 this.getListCity()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
   getListDistrict(){
      var data = { 
          SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          CityID: this.list.StoresInfo.City,
      }
        var that = this
       this.ajax('getListDistrict.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.DistrictList = res.data
            }

        })
    // const crs = await getListDistrict({
    //       token: localStorage.getItem("token"),
    //       CityID: this.list.StoresInfo.City,

    //     });
    //     if (crs.orsuccess == "1") {
    //       this.DistrictList = crs.data
    //     }
    },
   getListCity(){
        var data = { 
          SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          ProvinceID: this.list.StoresInfo.Province,
      }
        var that = this
       this.ajax('getListCity.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
            that.cityList = res.data
            }

        })
    // const crs = await getListCity({
    //       token: localStorage.getItem("token"),
    //       ProvinceID: this.list.StoresInfo.Province,

    //     });
    //     if (crs.orsuccess == "1") {
    //       this.cityList = crs.data
    //     }
    },
    getListProvince(){
          var data = { 
            SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token")
      }
        var that = this
       this.ajax('getListProvince.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.provinceList = res.data
            }

        })

},
    toArea(){
      this.list.StoresInfo.Area = ''
      this.DistrictList=''
      this.getListDistrict()
    },
    tocity(){
      this.list.StoresInfo.City = ''
      this.cityList=''
      this.list.StoresInfo.Area = ''
      this.DistrictList=''
      this.getListCity()
      // getListDistrict
    },
    choo(e){
      console.log(e.point.lng)
      this.list.StoresInfo.DWAddress = e.address
      this.list.StoresInfo.longitude = e.point.lng;
      this.list.StoresInfo.latitude =e.point.lat

  },
    getLocationPoint(e) {

      // this.lng = e.point.lng;
      // this.lat = e.point.lat;

      console.log(e.point)
      let geoc= new BMap.Geocoder();
      var that = this

      /* 创建地址解析器的实例 */
      //  var geoc = new BMapGL.Geocoder();

      geoc.getLocation(e.point, function(rs){
          var addComp = rs.addressComponents;
          that.list.StoresInfo.DWAddress =   addComp.province + ", " + addComp.city + ", " + addComp.district + ", " + addComp.street + ", " + addComp.streetNumber
      })
      this.longitude
      this.list.StoresInfo.longitude = e.point.lng;
      this.list.StoresInfo.latitude =e.point.lat

      /* 获取位置对应的坐标 */
      // geoCoder.getPoint(this.addressKeyword, point => {
      //   this.selectedLng = point.lng;
      //   this.selectedLat = point.lat;
      // });
      // /* 利用坐标获取地址的详细信息 */

      geoc.getLocation(e.point, res=>{
          console.log(res);
      })
     },
        searchMap(){
      this.provinceList.forEach(items => {
         if(items.ProvinceID== this.list.StoresInfo.Province){
              this.provinceName= items.ProvinceName
          }
      });
      this.cityList.forEach(items => {
         if(items.CityID == this.list.StoresInfo.City){
              this.cityName= items.CityName
          }
      });
      this.DistrictList.forEach(items => {
          if(items.DistrictID == this.list.StoresInfo.Area){
              this.AreaName = items.DistrictName
          }
      });
      this.map = this.provinceName + this.cityName + this.AreaName + this.list.StoresInfo.DWAddress
    },
    toSave(){
        var list = this.menu1 
        var list1 = this.list.listMenuSetting
        list1.forEach(items => {
          items.isShow = 0
        });
        for(var i = 0;i < list.length;i++){
          for(var j = 0; j <list1.length;j++){
            if( list[i].MenuType == list1[j].MenuType){
              for(var k = 0 ;k<list1.length;k++){
                if(list1[k].sort == i +1){
                      var item = list1[k].sort
                      list1[k].sort =   list1[j].sort 
                      list1[j].sort  = item
                      list1[j].isShow = 1
                  }
              }
            }
          }
        }
        var qlist = this.ListPreAboutForms
        var qlist1 = this.list.listPhoneSetting

        qlist1.forEach(items => {
            items.isShow = 0
        });
        for(var i = 0;i < qlist.length;i++){
            for(var j = 0; j <qlist1.length;j++){
              if( qlist[i].PhoneType == qlist1[j].PhoneType){    
                  for(var k = 0 ;k<qlist1.length;k++){
                          if(qlist1[k].sort == i +1){
                              var item = qlist1[k].sort
                              qlist1[k].sort =   qlist1[j].sort 
                              qlist1[j].sort  = item
                              qlist1[j].isShow = 1
                          }
                  }
              }
            }
        }
      var lbimgs = ''
       if(this.img1 !='' && this.img1 )
        lbimgs = lbimgs + this.img1 + ','
       if(this.img2 !='' && this.img2)
        lbimgs = lbimgs  +this.img2  + ','
       if(this.img3 !=''&& this.img3)
        lbimgs= lbimgs  + this.img3
      
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            ListPhoneSetting:qlist1,
            ListMenuSetting:list1,
            templateType:this.list.StoresInfo.templateType,
            Name:this.list.StoresInfo.StoresName,
            Phone:this.list.StoresInfo.StoresPhone,
            StoresInfo:this.list.StoresInfo.StoresInfo,
            lbimgs:lbimgs,
            Province:this.list.StoresInfo.Province,
            City:this.list.StoresInfo.City,
            Area:this.list.StoresInfo.Area,
            DWAddress:this.list.StoresInfo.DWAddress,
            longitude:this.list.StoresInfo.longitude,
            latitude:this.list.StoresInfo.latitude,
        
        }

        var that = this
        this.ajax('editPhoneSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
               that.$message({
                  type: "success",
                  message: "修改成功",duration:2000,
                });
                that.getList()
          } 
       })
    },
    toColor(items){
        this.list.StoresInfo.templateType = items.ID
    },
    toyu(){
      this.show = false
        var list = this.menu1 
        var list1 = this.list.listMenuSetting
        list1.forEach(items => {
          items.isShow = 0
        });
        for(var i = 0;i < list.length;i++){
          for(var j = 0; j <list1.length;j++){
            if( list[i].MenuType == list1[j].MenuType){
              for(var k = 0 ;k<list1.length;k++){
                if(list1[k].sort == i +1){
                      var item = list1[k].sort
                      list1[k].sort =   list1[j].sort 
                      list1[j].sort  = item
                      list1[j].isShow = 1
                  }
              }
            }
          }
        }
        var qlist = this.ListPreAboutForms
        var qlist1 = this.list.listPhoneSetting
        qlist1.forEach(items => {
            items.isShow = 0
        });
        for(var i = 0;i < qlist.length;i++){
          for(var j = 0; j <qlist1.length;j++){
            if( qlist[i].PhoneType == qlist1[j].PhoneType){    
                for(var k = 0 ;k<qlist1.length;k++){
                        if(qlist1[k].sort == i +1){
                            var item = qlist1[k].sort
                            qlist1[k].sort =   qlist1[j].sort 
                            qlist1[j].sort  = item
                            qlist1[j].isShow = 1
                        }
                }
            }
          }
        }
      var lbimgs = ''
       if(this.img1 !='' || this.img1 )
        lbimgs = lbimgs + this.img1 + ','
      if(this.img2 !='' || this.img2)
        lbimgs = lbimgs  +this.img2  + ','
      if(this.img3 !=''|| this.img3)
        lbimgs= lbimgs  + this.img3
         var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ListPhoneSetting:qlist1,
          ListMenuSetting:list1,
          templateTypeLS:this.list.StoresInfo.templateType,
          NameLS:this.list.StoresInfo.StoresName,
          PhoneLS:this.list.StoresInfo.StoresPhone,
          lbimgs:lbimgs

      }
          var that = this
  if(this.list.listPhoneSettingYL.length == 0 && that.sh == 0){
      this.ajax('addPhoneSettingYL.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.show = true
              that.sh = 1
              // that.getList()
          } 
       })
  } else {
      this.ajax('editPhoneSettingYL.aspx ',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.show = true
               that.sh = 1
              // that.getList()
          } 
       })
  }

      // this.keydata  = false
  

    },

    getList(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          // CardType:this.activeName
      }

      // this.keydata  = false
      var that = this
      const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
      this.ajax('getPhoneSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.timer = new Date().getTime()
              that.list = res.data
              that.map = res.data.StoresInfo.DWAddress
              var ListPreAboutForms = []
              that.module = res.data.listPhone
                that.menu = res.data.listMenu
              res.data.listPhoneSetting.forEach(items => {
                that.module.forEach(item => {
                  if(items.PhoneType == item.PhoneType){
                    if(items.isShow == 1){
                          item.show = true
                          var main = {
                              type:item.type,
                              show:false,
                              clickShow:false,
                              name:item.name,
                              sort : items.sort,
                              PhoneType:items.PhoneType
                        }
                        if(item.type == 'dhcd'){
                          var menList = []
                           res.data.listMenuSetting.forEach(mens => {
                              that.menu.forEach(men => {
                                if(mens.MenuType == men.MenuType){
                                  if(mens.isShow == 1){
                                    var itemMen = men 
                                    itemMen.sort = mens.sort
                                      itemMen.moveShow = false
                                    men.show = true
                                    menList.push(itemMen)
                                  }
                                }
                              })
                          //     item.show = true  
                          //   })

                          })
                 
                          that.menu1 = menList
                          //   this.menu.forEach(item => {
                          //     item.show = true  
                          //   })
          
                        }
                      ListPreAboutForms.push(main)
                    }
                  }
                });
              });

            that.ListPreAboutForms = ListPreAboutForms    
                // that.keydata = true
          that.changeNum()
          } 
          loading.close();

       })
    },
    changeNum(){
      if(this.list.listStoresImg.length>0 && this.list.listStoresImg[0].ImgUrl !='' ){
                this.img1 = this.list.listStoresImg[0].ImgUrl
              } else {
                this.img1 =""
              }
      if(this.list.listStoresImg.length>1 && this.list.listStoresImg[1].ImgUrl !=''){
                this.img2 = this.list.listStoresImg[1].ImgUrl
              }else {
                this.img2 =""
              }
      if(this.list.listStoresImg.length>2 && this.list.listStoresImg[2].ImgUrl !=''){
           this.img3 = this.list.listStoresImg[2].ImgUrl
              }else {
                 this.img3 =""
        }
  var  arr = this.ListPreAboutForms
  var len = this.ListPreAboutForms.length
   for (var i = 0; i < len-1; i++) {
    for (var j = 0; j < len - 1 - i; j++) {
         // 相邻元素两两对比，元素交换，大的元素交换到后面
        if (arr[j].sort > arr[j + 1].sort) {
            var temp = arr[j];
            arr[j] = arr[j+1];
            arr[j+1] = temp;
        }
    }
    }
    this.ListPreAboutForms = arr

  var arr1 = this.menu1 
  var len1 = this.menu1.length
   for (var i = 0; i < len1-1; i++) {
    for (var j = 0; j < len1 - 1 - i; j++) {
         // 相邻元素两两对比，元素交换，大的元素交换到后面
        if (arr1[j].sort > arr1[j + 1].sort) {
            var temp = arr1[j];
            arr1[j] = arr1[j+1];
            arr1[j+1] = temp;
        }
      }
    }
    this.menu1 = arr1
  },
    uploadPicture(name) {
      this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    //图片上传成功后

    handleUploadSuccess(data) {
       this.cropperModel = false
    
      if(this.cropperName == 'img1'){
          this.img1 = data.url
      }
            if(this.cropperName == 'img2'){
          this.img2 = data.url
      }
            if(this.cropperName == 'img3'){
          this.img3 = data.url
      }
      this.cropperModel = false;
    },
    delItems(item,index){
      this.module.forEach(items => {
          if(items.type == item.type){
              items.show = false
          }
      });
      this.ListPreAboutForms.splice(index, 1)
    },
    delItems1(item,index){
      this.menu.forEach(items => {
          if(items.name == item.name){
              items.show = false
          }
      });
      this.menu1.splice(index, 1)
    },
    toTop(items,index){
        var list = items
        var list = items
        this.ListPreAboutForms[index] = this.ListPreAboutForms[index -1] 
        this.ListPreAboutForms[index - 1] = list
        this.timer = new Date().getTime()
    },
    toDown(items,index){
        var list = items
        this.ListPreAboutForms[index] = this.ListPreAboutForms[index +1] 
        this.ListPreAboutForms[index + 1] = list
        this.timer = new Date().getTime()
    },
    clickitems(item){
      this.typeList = item
      this.ListPreAboutForms.forEach(items => {
          
          if(items.type == item.type){
        
              items.clickShow = true
          } else {
            items.clickShow = false
          
          }
      });
    },
    onMouseOver(items){
           items.show = true
       },
    onMouseLeave(items){
          items.show =  false

      },
    onMouseLeave1(items){
      items.moveShow =  false
      this.$forceUpdate()
      
      },
    onMouseOver1(items){
     
      items.moveShow = true
      this.$forceUpdate()
  // this.timer1 = new Date().getTime()

      },
    dragstart(value) {
            this.oldData = value
        },

        // 记录移动过程中信息
    dragenter(value, e) {
            this.newData = value
            e.preventDefault()
        },

        // 拖拽最终操作
    dragend(value, e) {
            if (this.oldData !== this.newData) {
                let oldIndex = this.ListPreAboutForms.indexOf(this.oldData)
                let newIndex = this.ListPreAboutForms.indexOf(this.newData)
                let newItems = [...this.ListPreAboutForms]
                // 删除老的节点
                newItems.splice(oldIndex, 1)
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldData)
                this.ListPreAboutForms = [...newItems]
            }
    },
    toTop1(items,index){
        var list = items

        this.menu[index] = this.menu[index -1] 
        this.menu[index - 1] = list
        this.menu1[index - 1].moveShow = false
        this.menu1 = []
         this.menu.forEach(items => {
            if(items.show == true){
              this.menu1.push(items)
            }
        });
        this.timer1 = new Date().getTime()
    },
    toDown1(items,index){
        var list = items
        this.menu[index] = this.menu[index +1] 
        this.menu[index + 1] = list
         this.menu1[index +1].moveShow = false
        this.menu1 = []
                this.menu.forEach(items => {
                    if(items.show == true){
                      this.menu1.push(items)
                    }
                });
        this.timer1 = new Date().getTime()
    },


        // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    dragover(e) {
            e.preventDefault()
    },

    dragstart1(value) {  

        this.oldData1 = value

    },

        // 记录移动过程中信息
    dragenter1(value, e) {

        this.newData1 = value
        e.preventDefault()

           
    },

        // 拖拽最终操作
    dragend1(value, e) {    
      if (this.oldData1 !== this.newData1) {

                let oldIndex = this.menu.indexOf(this.oldData1)
                let newIndex = this.menu.indexOf(this.newData1)
              
                let newItems = [...this.menu]
                // 删除老的节点
                newItems.splice(oldIndex, 1)
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldData1)
                this.menu = [...newItems]
                this.menu1 = []
                this.menu.forEach(items => {
                    if(items.show == true){
                      this.menu1.push(items)
                    }
                });
                this.timer1 = new Date().getTime()

      }
    },
        // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    dragover1(e) {

            e.preventDefault()

    },

    toChoose(items){
        items.show = !items.show
        // console.log(items)
        // console.log('222',this.ListPreAboutForms.length)
        if(items.show == true){
            var list = {
            length:this.ListPreAboutForms.length,
            type:items.type,
            show:false,
            clickShow:false,
            name:items.name,
            PhoneType:items.PhoneType
            }
            if(items.type == 'dhcd'){
                    this.menu1 = [...this.menu]
                  this.menu.forEach(item => {
                    item.show = true
                  });
            }
             this.ListPreAboutForms.push(list)      
        } else {
            for(var i = 0 ;i<this.ListPreAboutForms.length;i++){
                if(this.ListPreAboutForms[i].type == items.type){
                    this.ListPreAboutForms.splice(i, 1)
                    if(items.type == 'dhcd'){
                       this.menu.forEach(item => {
                          item.show = false
                       });
                       this.menu1 = []
                    }
                   
                }
            }
        }

    },
     toChoose1(items){
        items.show = !items.show
        // if(items.show == false){
        //     // this.menu1.forEach((item,index)=> {
        //     //     if(item.name == items.name){
        //     //           this.menu1.splice(index, 1)
        //     //     }
        //     // })
        // } else {
        //   items.moveShow = false
        //   // this.menu1.push(items)
        // }
    this.menu1 = []
    this.menu.forEach(item =>{
          if(item.show == true)
          this.menu1.push(item)
    })

      this.timer1 = new Date().getTime()

    },
    toHome(){
        this.$router.go(-1)
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件

    //显示编辑界面

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          deptSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
  
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("公司保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deptDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("公司删除失败，请稍后再试！");
            });
        })
        .catch(() => {
            ;
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>
<style>
.el-popover{
  min-width: 10px;
}
</style>
<style scoped>
.bgColor1{
   cursor:pointer;
  height: 2vw;
  width: 2vw; 
  border-radius: 100%;
  border:3px solid #0380e0;
}
.bgColor{
   cursor:pointer;
  height: 2vw;
  width: 2vw; 
  border-radius: 100%;
  border:3px solid #ffffff;
}
.list-img-box{
  margin-left:20px;
  margin-top:20px;
}
.rightTitle{
  margin-left:10px;
  font-size:15px;
  font-weight: 600;
}
.terbg{
  background-color: #c7c7c7;
  height: 20vh;
}
.imgbg{
  background-color: #c7c7c7;
  height: 25vh;
}
.jieshao{
  height:10vh;
   background-color: #c7c7c7;
}
.buttonbac{
  width: 40px;
  height: 20px;
    font-size: 12px;
    line-height: 1;
    border-radius: 2px;
    opacity: 1;
    color: #fff;
    background: rgba(0,0,0,.4);
    cursor: pointer;
}
.topButton{
  position: absolute;
  right: 0;
  top: 0;
}
.hen:hover{
    border:1px dashed #22a1ff; 
}
.hen{
  width: 95%;
  border: 1px dashed #ffffff;
  margin-left: 2.5%;
  position: relative;
}
.hen1{
  width: 95%;
  border:1px dashed #22a1ff; 
  margin-left: 2.5%;
  position: relative;
}
.boxx{
    border:1px dashed #22a1ff; 
    cursor:pointer;
    width:4.5vw;
    height:4.5vw;
    margin-left:4%;
    margin-top:10px;
    background: #fafafa;
    position: relative !important;
}
.boxx1{   
    cursor:pointer;
    position: relative !important;
    width: 4.5vw;
    height:4.5vw;
    margin-left:4%;
    margin-top:10px;
     border:1px dashed #22a1ff; 
    background: #fafafa;
}
.box2:hover{
     border:1px dashed #22a1ff; 
}
.box2{
    cursor:pointer;
    position: relative;
    width: 4.5vw;
    height:4.5vw;
    margin-left:4%;
    margin-top:10px;
    border: 1px dashed #ececec;
    background: #fafafa;
}
.box3{
   /* border: 1px dashed #ececec; */
  background: #fafafa;
  height:3.5vw;
  width:25%;

  
}
.moud{
    display: flex;
    flex-wrap: wrap;
}
.icon1{
    font-size:20px;
    color: rgb(76, 76, 76);
}
.box1{
    cursor:pointer;
    width: 4.5vw;
    height:4.5vw;
    margin-left:4%;
    position: relative;
    margin-top:10px;
    border: 1px dashed #ececec;
    background: #fafafa;
}
.box1:hover{
  border:1px dashed #22a1ff;
}
.font1{
    margin-top:3px;
    color: rgba(0,0,0,.65);
    font-size: 10px;

    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum";
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.font{
    margin-top:5px;
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: "tnum";
}
.icon{
   font-size:30px;
    color: rgb(76, 76, 76);
}
.box:hover{
  border:1px dashed #22a1ff;
}
.box{
    cursor:pointer;
    width:4.5vw;
    height:4.5vw;
    margin-left:4%;
    margin-top:10px;
    border: 1px dashed #ececec;
    background: #fafafa;
}
.phone{
    background-color:white;
    width: 60%;
    height: 98%;
    margin-top: 20px;
    overflow: auto;
}
.contain{
    width:100%;

    background-color: darkgrey;

       /* background: #f7f7f7; */

}
.main{
    padding-top: 30px;
    width: 50vw;
    height: calc(95vh - 90px);
    overflow: auto;
    
}
.right{ 
   padding-top: 30px;
    width: 25vw;
    background: #fff;
    height: calc(96vh - 90px);
}
.left{
   padding-top: 30px;
    position: relative;
    z-index: 4;
    width: 18vw;
   height: calc(96vh - 90px);
    overflow: auto;
    background: #fff;

}
</style>

 



// WEBPACK FOOTER //
// src/views/phoneSetting/phoneSetting.vue